<template>
  <v-container fluid pa-0>
    <v-layout>
      <v-flex>
        <div class="input-group radio-group--row">
          <label class="v-label v-label--active theme--light">{{ label }}</label>
          <v-chip
            v-for="item in value" :key="item.text"
            v-bind="$attrs"
            v-on="$listeners"
          >
            <v-avatar v-if="item.image">
              <img :src="item.image" alt="item.text">
            </v-avatar>
            <v-icon left v-if="item.ico">{{ item.ico }}</v-icon>
            <a class="chip-lnk" v-if="item.url" :href="item.url">{{ item.text }}</a>
            <router-link class="chip-lnk" v-else-if="item.route" :to="item.route">{{ item.text }}</router-link>
            <span v-else>{{ item.text }}</span>
          </v-chip>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'nx-form-chips',
  props: {
    value: Array,
    label: String,
  },
};
</script>

<style lang="stylus">
a.chip-lnk {
  color: rgba(0, 0, 0, 0.87);
}
</style>
